<template>
    <div class="anchor-navigation-bar-mobile">
        <div class="container">
            <button class="btn btn-link" @click="toggleSection">
                <span class="text">{{ title }}</span>
                <IconChevronUp v-if="expandSection" class="icon" />
                <IconChevronDown v-else class="icon" />
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps<{title:string}>();
const expandSection = ref(false)
const emit = defineEmits<{
  (e: 'toggle', expandState: boolean): void
}>()

const toggleSection = () => {
    expandSection.value = !expandSection.value
    emit('toggle', expandSection.value)
}
</script>